// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"index_colorPicker__Dcr_a","colorBolck":"index_colorBolck__3bmVd","colorText":"index_colorText__1sf3S","colorBg":"index_colorBg__TKbTA"};